import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './guard/auth.guard';
import { NoAuthGuard } from './guard/no-auth.guard';
import { TokenInterceptor } from './interceptor/token.interceptor';
import { AppSettings } from './configs/app.settings';
import { DataTableComponent } from './component/data-table/data-table';
import { CheckboxInputComponent } from './component/form-inputs/checkbox-input/checkbox-input.component';
import { DateTimeInputComponent } from './component/form-inputs/datetime-input/datetime-input.component';
import { EmailInputComponent } from './component/form-inputs/email-input/email-input.component';
import { NumberInputComponent } from './component/form-inputs/number-input/number-input.component';
import { PasswordInputComponent } from './component/form-inputs/password-input/password-input.component';
import { PhoneInputComponent } from './component/form-inputs/phone-input/phone-input.component';
import { SelectInputComponent } from './component/form-inputs/select-input/select-input.component';
import { TextInputComponent } from './component/form-inputs/text-input/text-input.component';
import { TextareaInputComponent } from './component/form-inputs/textarea-input/textarea-input.component';
import { RadioInputComponent } from './component/form-inputs/radio-input/radio-input';
import { InputFocus } from './component/form-inputs/input-focus.directive';
import { PhonePipe } from './component/form-inputs/phone.pipe';
import { SkeletonComponent } from './component/skeleton/skeleton.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserHelper } from './helper/browser.helper';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SuggestInputComponent } from './component/form-inputs/suggest-input/suggest-input';
import { LuxonPipe } from './pipe/luxon.pipe';
import { BitwiseInputComponent } from './component/form-inputs/bitwise-input/bitwise-input';
import { DataChartComponent } from './component/data-chart/data-chart';
import { NgChartsModule } from 'ng2-charts';
import { MappedItemsTableComponent } from './component/mapped-items-table/mapped-items-table';
import { AuctionGuard } from './guard/auction.guard';
import { DeactivateGuard } from './guard/deactivate.guard';
import { InviteGuard } from './guard/invite.guard';
import { ContentPreviewComponent } from './component/content-preview/content-preview.component';
import { ContentUploadComponent } from './component/content-upload/content-upload.component';
import { HelpBubbleComponent } from './component/help-bubble/help-bubble.component';
import { HelpIconComponent } from './component/help-icon/help-icon.component';


@NgModule({
  declarations: [
    LuxonPipe,
    BitwiseInputComponent,
    RadioInputComponent,
    SkeletonComponent,
    InputFocus,
    PhonePipe,
    ContentUploadComponent,
    ContentPreviewComponent,
    EmailInputComponent,
    PhoneInputComponent,
    DateTimeInputComponent,
    TextareaInputComponent,
    SelectInputComponent,
    NumberInputComponent,
    TextInputComponent,
    CheckboxInputComponent,
    PasswordInputComponent,
    DataTableComponent,
    SuggestInputComponent,
    DataChartComponent,
    MappedItemsTableComponent,
    HelpBubbleComponent,
    HelpIconComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HttpClientModule,
    NgxPaginationModule,
    NgChartsModule
  ],
  providers: [
    AuthGuard,
    NoAuthGuard,
    AuctionGuard,
    DeactivateGuard,
    InviteGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    AppSettings,
    BrowserHelper,
    InAppBrowser, 
    // { // used for global unhandled exception capture and logging to server
    //   provide: ErrorHandler,
    //   useClass: ErrorLoggingService
    // },
  ],
  exports: [
    SkeletonComponent,
    InputFocus,
    PhonePipe,
    BitwiseInputComponent,
    RadioInputComponent,
    ContentUploadComponent,
    ContentPreviewComponent,
    EmailInputComponent,
    PhoneInputComponent,
    DateTimeInputComponent,
    TextareaInputComponent,
    SelectInputComponent,
    NumberInputComponent,
    TextInputComponent,
    CheckboxInputComponent,
    PasswordInputComponent,
    DataTableComponent,
    CommonModule,
    FormsModule,
    IonicModule,
    SuggestInputComponent,
    LuxonPipe,
    DataChartComponent,
    MappedItemsTableComponent,
    HelpBubbleComponent,
    HelpIconComponent
  ]
})
export class CoreModule { }
